


















































































import { Component, Vue } from 'vue-property-decorator'
import InformationPopup from '@/components/InformationPopup.vue'
import NavigationButtons from '../ui/NavigationButtons.vue'
import OptionModule from '@/components/OptionModule.vue'
import GlassOption from '@/data/glass-option'
import GlassOptionValue from '@/data/glass-option-value'
import { ModuleOption, InformationCodes } from '@/data/enums'

import '@/icons/options-monoplus'
import '@/icons/options-pro410'
import '@/icons/options-mdm'
import '@/icons/options-grinding'
import '@/icons/options-aspherical'
import '@/icons/options-coloring'
import '@/icons/options-prisma'

@Component({
  components: {
    InformationPopup,
    NavigationButtons,
    OptionModule
  }
})
export default class ExtraOptionsModule extends Vue {
  private currentInformationWebsite: InformationCodes | string = ''
  private showInfo: boolean = false

  private get showPrice (): boolean {
    return this.$store.state.data.optician.showPrices
  }

  private get optionIds (): ModuleOption[] | undefined {
    if (this.$store.state.cart.currentItem.type) {
      return this.$store.state.cart.currentItem.type.options
        .filter((option: GlassOption) => (option.optionId !== 5 && option.fullscreen !== 1))
        .map((option: GlassOption) => option.optionId)
    }
  }

  private onInfoClick (code: InformationCodes) {
    this.currentInformationWebsite = code
    this.showInfo = true
  }

  private toggleOptionValue (optionValue: GlassOptionValue) {
    this.$store.dispatch('cart/toggleOptionValue', optionValue)
      .catch((err) => console.error(err))
  }
}
